(() => {
  angular
    .module('app.campaign')
    .controller('EditModalController', EditModal);

    EditModal.$inject = ['sourceFor', 'close'];

  function EditModal(sourceFor, close) {
    const vm = this;
    vm.sourceFor = sourceFor;
    vm.confirmEdit = () => {
      close(true, 500);
    };
    vm.hideWarning = () => {
      return window.localStorage.getItem('ir_hide_warning');
    };
    vm.toggleWarning = () => {
      const hideWarning = vm.hideWarning();
      window.localStorage.setItem('ir_hide_warning', !hideWarning);
    };
  }
})();